import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

export const Portal = ({ selector, insertBefore = "true", children }) => {

    const [container] = useState(() => {
        const el = document.createElement('div');
        el.setAttribute('data-portal', 'tcc-portal');
        return el;
    });


    useEffect(() => {
        const l = document.querySelector(selector);
        if (insertBefore) {
            l.insertBefore(container, l.childNodes[0]);
        } else {
            l.appendChild(container)
        }

        return () => {
            const l = document.querySelector(selector);
            l.removeChild(container)
        };

    }, [container, insertBefore, selector])

    return ReactDOM.createPortal(children, container)
}

